﻿const element = document.querySelector('#custom-middle-navbar');
const mainmenu = document.querySelector('#custom-middle-navbar #middle-nav');

if (element) {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            let force = entry.intersectionRatio < 1;
          entry.target.classList.toggle('shadow-xl', force);
          
          mainmenu.classList.toggle('py-4', !force);
        });

    }, { threshold: 1.0 });

    observer.observe(element);
}
